import { __decorate, __metadata } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvIntersectionObserver";
/**
 * A component capable of detecting when it becomes visible, based on the `IntersectionObserver`.
 */
let LvIntersectionObserver = class LvIntersectionObserver extends UIComponent {
    constructor() {
        super(...arguments);
        this.intersectionObserver = null;
    }
    mounted() {
        const options = this.options ?? {};
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
            if (entry && entry.isIntersecting) {
                /**
                 * When the element becomes visible.
                 */
                this.$emit("intersect");
            }
        }, options);
        this.intersectionObserver.observe(this.$el);
    }
    beforeDestroy() {
        if (this.intersectionObserver != null) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = null;
        }
    }
};
__decorate([
    Prop({ type: Object, required: false, default: null }),
    __metadata("design:type", Object)
], LvIntersectionObserver.prototype, "options", void 0);
LvIntersectionObserver = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvIntersectionObserver);
export default LvIntersectionObserver;
//# sourceMappingURL=script.js.map